/**
 * @file This file contains the configuration for ambient weather effects.
 * @module weatherConfig
 */

export const weatherConfig = {
    rain: {
        frequency: 50, // Chance to start is 1/50 per turn
        duration: 10,  // Lasts for 10 turns
        particle: {
            count: 100,
            movement: 'fall',
            content: ['💧'],
            baseSpeed: 3,
            wind: 1,
        }
    },
    snow: {
        frequency: 60,
        duration: 15,
        particle: {
            count: 80,
            movement: 'fall',
            content: ['❄️','⚪'],
            baseSpeed: 1,
            wind: 0.5,
        }
    },
    storm: {
        frequency: 100,
        duration: 5,
        particle: {
            count: 150,
            movement: 'fall',
            content: ['💧'],
            baseSpeed: 10,
            wind: 2,
        },
        lightning: {
            frequency: 0.01 // 1% chance per frame
        }
    },
    sunny: {
        frequency: 30,
        duration: 20,
        particle: {
            count: 1,
            movement: 'traverse',
            content: ['☀️','🌞','🛸'],
            size: '6em', // Make it much larger
            baseSpeed: 1, // Sideways speed
            wind: 0.3, // Gentle vertical drift
            className: 'sun-glow'
        }
    },
    moon: {
        frequency: 30,
        duration: 20,
        particle: {
            count: 1,
            movement: 'traverse',
            content: ['🌑','🌕','🌑','🌒','🌓','🌔','🌕','🌖','🌗','🌘','🌙','🌚','🌛','🌜','🌝'],
            size: '6em', // Make it much larger
            baseSpeed: 1, // Sideways speed
            wind: 0.3, // Gentle vertical drift
        }
    },
    cloudy: {
        frequency: 40,
        duration: 25,
        particle: {
            count: 8, // A few clouds
            movement: 'traverse',
            content: ['☁️','🌧️','🌨️','⛈️'],
            size: '4em',
            baseSpeed: 0.5, // Slower than the sun
            wind: 0.05 // Very gentle vertical drift
        }
    },
    foggy: {
        frequency: 70, // Less frequent than clouds
        duration: 35,  // Lasts longer
        particle: {
            count: 16, // A bit more dense
            movement: 'traverse',
            content: ['☁️', '🌫️'],
            size: '5em', // A bit larger
            baseSpeed: 0.3, // Even slower
            wind: 0.02, // Less vertical drift
            className: 'fog-effect'
        }
    }
};